import {  SET_CURRENT_TAB } from '../actions/TabActions';
const initialState = {
    currentTab: '1'
  };
  
  export const rideTrackReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_CURRENT_TAB:
        return {
          ...state,
          currentTab: action.payload
        };
      
      default:
        return state;
    }
  };